import i18next from 'i18next'
import * as React from 'react'
import { useState } from 'react'
import { BasicButton, RadioButton } from '../../../../'
import { Logger } from '../../../../../modules'
import { ArrowBackIcon } from '../../../../Icons'
import { Section } from '../../../../Sections'
import Styles from './AdminSSOSwitch.module.scss'
import { AdminSSOSwitchSectionProps } from './interfaces'

export const AdminSSOSwitch = ({ navigate: navigateSection, context }: AdminSSOSwitchSectionProps): React.ReactElement => {
	const [checkedValue, setCheckedValue] = useState('continue')

	const handleSubmit = async (event: React.FormEvent<HTMLFormElement>): Promise<void> => {
		event.preventDefault()
		event.stopPropagation()
		try {
			if (checkedValue === 'continue') {
				window.location.href = context.ssoLogin
				return
			} else {
				navigateSection('EmailSection', context)
			}
		} catch (e) {
			Logger.error(e)
		}
	}

	const handleGoBack = (): void => {
		navigateSection('SignInSection')
	}

	return (
		<Section
			side="right"
			title={
				<div className={Styles['title-container']}>
					<div className={Styles['back-arrow']} onClick={handleGoBack}>
						<ArrowBackIcon />
					</div>
					<div>{i18next.t('pages.login.adminSSOSwitch')}</div>
				</div>
			}
			className={Styles['admin-section']}
		>
			<form className={Styles['form']} onSubmit={handleSubmit} autoComplete="off">
				<div className={Styles['enter-email-text']}>{i18next.t('pages.login.adminSSOSwitchMessage')}</div>
				<div className={Styles['radios']}>
					<div>
						<RadioButton
							handleChange={(): void => {
								setCheckedValue('continue')
							}}
							value={'continue'}
							label={i18next.t('pages.login.adminSSOSwitchContinue')}
							isChecked={checkedValue === 'continue'}
						/>
					</div>
					<div>
						<RadioButton
							handleChange={(): void => {
								setCheckedValue('email')
							}}
							value={'email'}
							label={i18next.t('pages.login.adminSSOSwitchEmail')}
							isChecked={checkedValue === 'email'}
						/>
					</div>
				</div>
				<BasicButton variant="blue" elevation={true} type="submit">
					{i18next.t('pages.login.adminSSOContinue')}
				</BasicButton>
			</form>
		</Section>
	)
}
